// src/UserMenu.js
import React, { useState, useRef, useEffect } from 'react';
import { B } from './constants';
import { useAuth } from './AuthContext';

export default function UserMenu({ goScreen }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const { user, logout } = useAuth();

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const initials = user?.name?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0,2) || '?';

  return (
    <div ref={ref} style={{ position:'relative' }}>
      <button onClick={() => setOpen(!open)} style={{ width:38, height:38, borderRadius:'50%', background:`linear-gradient(135deg,${B.forest},${B.mint})`, border:`2px solid ${open?B.mint:'rgba(255,255,255,0.2)'}`, cursor:'pointer', color:'white', fontFamily:"'Montserrat',sans-serif", fontWeight:800, fontSize:13, display:'flex', alignItems:'center', justifyContent:'center', transition:'border-color 0.2s' }}>
        {initials}
      </button>

      {open && (
        <div style={{ position:'absolute', top:48, right:0, background:'rgba(26,35,50,0.85)', backdropFilter:'blur(16px)', WebkitBackdropFilter:'blur(16px)', borderRadius:16, border:'1px solid rgba(255,255,255,0.1)', boxShadow:'0 16px 48px rgba(0,0,0,0.5)', minWidth:220, zIndex:300, animation:'fadeUp 0.2s ease', overflow:'hidden' }}>
          <div style={{ padding:'16px 20px', borderBottom:'1px solid rgba(255,255,255,0.07)' }}>
            <div style={{ width:44, height:44, borderRadius:'50%', background:`linear-gradient(135deg,${B.forest},${B.mint})`, display:'flex', alignItems:'center', justifyContent:'center', fontWeight:800, color:'white', fontSize:16, marginBottom:10 }}>{initials}</div>
            <p style={{ color:'white', fontWeight:700, fontSize:15, marginBottom:2 }}>{user?.name}</p>
            <p style={{ color:'#666', fontSize:12 }}>{user?.email}</p>
          </div>
          {[
            { icon:'🗺️', label:'My Trips',   action:() => { goScreen('trips'); setOpen(false); } },
            ...((user?.isCreator || user?.isInfluencer) ? [{
              icon: '📊',
              label: 'Creator Analytics',
              action: () => { setOpen(false); window.location.href = '/creator/analytics'; },
            }] : []),
            ...((user?.isAdmin === true) ? [{
              icon: '🛡️',
              label: 'Admin',
              action: () => { setOpen(false); window.location.href = '/admin'; },
            }] : []),
            { icon:'⚙️', label:'Settings',   action:() => { goScreen('settings'); setOpen(false); } },
          ].map(({ icon, label, action }) => (
            <button key={label} onClick={action} style={{ width:'100%', padding:'12px 20px', background:'none', border:'none', cursor:'pointer', display:'flex', alignItems:'center', gap:12, color:'#ccc', fontSize:14, fontFamily:"'Montserrat',sans-serif", fontWeight:600, textAlign:'left', transition:'background 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.background='rgba(255,255,255,0.05)'}
              onMouseLeave={e => e.currentTarget.style.background='none'}>
              <span style={{ fontSize:16 }}>{icon}</span> {label}
            </button>
          ))}
          <div style={{ borderTop:'1px solid rgba(255,255,255,0.07)', padding:'8px 0' }}>
            <button onClick={() => { logout(); setOpen(false); }} style={{ width:'100%', padding:'12px 20px', background:'none', border:'none', cursor:'pointer', display:'flex', alignItems:'center', gap:12, color:'#ff6b7a', fontSize:14, fontFamily:"'Montserrat',sans-serif", fontWeight:600, textAlign:'left' }}
              onMouseEnter={e => e.currentTarget.style.background='rgba(220,53,69,0.1)'}
              onMouseLeave={e => e.currentTarget.style.background='none'}>
              🚪 Sign Out
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
